/**
 * Tokens de sombra del Design System — traslado del frame "Shadows" de Figma
 * (node 4:544). Los valores del frame (2 capas de drop-shadow, color #0F1729 con
 * distintas alfas) coinciden EXACTAMENTE con los tokens que la app ya tiene en
 * `index.css` (`--shadow-sm/md/lg`, expuestos también como Tailwind `shadow-sm/md/lg`).
 *
 * Por eso NO se redefinen valores: cada token referencia el `var(--shadow-*)` del
 * proyecto (una sola fuente de verdad → la página de docs y la app nunca divergen).
 * Ya son usables app-wide vía `shadow-sm` / `shadow-md` / `shadow-lg` de Tailwind.
 *
 * NOTA (typos del frame de Figma): las filas 2 y 3 están etiquetadas "rounded-md" /
 * "rounded-lg" (copy-paste de la page de Radius) y el header de la 3ª columna dice
 * "Radius"; las VARIABLES, en cambio, son `shadow-sm/md/lg` (lo que se usa acá).
 */

export interface ShadowToken {
  /** Nombre del token, ej. 'shadow-md'. */
  name: string;
  /** Propósito / cuándo usarlo. */
  purpose: string;
  /** Valor CSS (referencia al token del proyecto). */
  boxShadow: string;
}

export const SHADOW_TOKENS: ShadowToken[] = [
  { name: 'shadow-sm', purpose: 'A definir', boxShadow: 'var(--shadow-sm)' },
  { name: 'shadow-md', purpose: 'A definir', boxShadow: 'var(--shadow-md)' },
  { name: 'shadow-lg', purpose: 'A definir', boxShadow: 'var(--shadow-lg)' },
];
